export const locationFields = [
  {
    name: "locationId",
    label: "Location ID",
    type: "text",
    required: true,
    readonly: true 
  },
  {
    name: "locationName",
    label: "Location Name",
    type: "text",
    required: true
  },
  {
    name: "locationType",
    label: "Location Type",
    type: "select",
    required: true,
    options: ["Retail Store", "Dark Store", "Warehouse", "CFC"]
  },
  {
    name: "addressLine1",
    label: "Address Line 1",
    type: "text",
    required: true
  },
  {
    name: "addressLine2",
    label: "Address Line 2",
    type: "text"
  },
  {
    name: "city",
    label: "City",
    type: "text",
    required: true
  },
  {
    name: "state",
    label: "State",
    type: "text",
    required: true
  },
  {
    name: "country",
    label: "Country",
    type: "select",
    required: true,
    options: ["India"] // or fetch dynamic list
  },
  {
    name: "pincode",
    label: "Pincode",
    type: "text",
    required: true
  },
  {
    name: "operationalGeoAreas",
    label: "Operational Geo Areas",
    type: "multiselect",
    required: true,
     options: ["Standard", "Premium", "Express"] 
  },
  {
    name: "serviceLevel",
    label: "Service Level",
    type: "select",
    required: true,
    options: ["Standard", "Premium", "Express"] 
  },
  
  {
    name: "createdBy",
    label: "Created By",
    type: "text",
    readonly: true
  },

  {
    name: "updatedBy",
    label: "Updated By",
    type: "text",
    readonly: true
  },
  {
    name: "updatedDate",
    label: "Updated Date",
    type: "text",
    readonly: true
  }
];



